import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';
export const getCountriesFunc = createAsyncThunk(
    "getCountries",
    async (query = '', thunkAPI) => {
        try {
            const res = await api.get(`dashboard/countries${query}`);
            return res.data.data.countries;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }

    }
)

const getCountriesSlicer = createSlice({
    name: "getCountries",
    initialState: {
        loading: null,
        data: [],
        error: null
    },
    reducer: {},
    extraReducers: (builder) => {
        builder.addCase(getCountriesFunc.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.apiErrors = {};
        })
            .addCase(getCountriesFunc.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.successMessage = action.payload?.message || "";

            })
            .addCase(getCountriesFunc.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.apiErrors = action.payload?.errors || {};
            });
    }
})

export default getCountriesSlicer.reducer;